import React from "react";
import "./styles/NewsPreview.scss";
import CustomSlider from "../../components/CustomSlider";
import BtnViewMore from "../../components/BtnViewMore";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../hooks/useLangNavigate";

const NewsPreview = () => {
  const { t } = useTranslation();
  const langNavigate = useLangNavigate();
  const handleBtn = () => {
    langNavigate("/news");
  };
  const news = t("news", { returnObjects: true }) as { path: string; title: string; date: string; des: string }[];
  return (
    <>
      <div id="news_preview_wrap">
        <div className="title_wrap">
          <div className="title">NEWS</div>
          <div className="des">저희 아키테코 그룹은 환경문제 앞서 여러 활동을 하고 있으며, 각종 업무 협약 체결 , ESG경영, 스마트그린, 등 다양한 분야에서 활동 하고있습니다.</div>
          <BtnViewMore onClick={handleBtn} />
        </div>
        <div className="content">
          <CustomSlider
            setting={{
              infinite: true,
              speed: 500,
              slidesToShow: 3,
              slidesToScroll: 3,
              autoplay: false,
              autoplaySpeed: 3000,
              arrows: false,
              draggable: false,
            }}
            navigation={{ pagingType: "type_01", color: "#111111", position: { bottom: "-100px", left: "700px" } }}
          >
            {news.map((content: { path: string; title: string; date: string; des: any }, index: number) => {
              return (
                <div
                  id={`${index}`}
                  className="card"
                  key={`${content.title}_${index}`}
                  onClick={() => {
                    langNavigate("/news");
                  }}
                >
                  <div className="img_box">
                    <img src={`${content.path}`} alt={`${content.title}`} />
                  </div>
                  <div className="name">{content.title}</div>
                  <div className="date">{content.date}</div>
                </div>
              );
            })}
          </CustomSlider>
        </div>
      </div>
    </>
  );
};

export default NewsPreview;
